<template>
<div class="pv-badge badge">
  <slot>
    {{ value.label || value.id }}
  </slot>
</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'PvBadge',
  props: {
    value: {
      type: Object,
      default: null,
    },
  },
});
</script>
